/* mixins/messageHandler */
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters([
            'getMessageMsg',
            'getMessageShow',
            'getMessageType'
        ])
    },

    methods: {
        ...mapActions([
            'resetMessage',
            'setMessage'
        ]),

        showMessage(type, message) {
            let msg = {
                message: message,
                show: true,
                type: type
            }

            this.setMessage(msg)
        }
    }
}